import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../HardwareFirstQuiz.module.scss';
import { ChipStep as ChipStepDef } from '../steps';

interface ChipStepProps {
  step: ChipStepDef<string>;
  selected: string[];
  onToggle(optionId: string): void;
  onNext(): void;
  canAdvance: boolean;
}

/**
 * A capped multi-select question. At the cap the unselected chips are disabled
 * rather than silently dropping an earlier pick, so the visitor's own choices
 * never move under them.
 */
export default function ChipStep({ step, selected, onToggle, onNext, canAdvance }: ChipStepProps) {
  const { t } = useTranslation();
  const atCap = selected.length >= step.maxSelect;

  return (
    <div className={styles.stepBody}>
      <h2 className={styles.stepTitle}>{t(step.titleKey)}</h2>
      <div className={styles.stepSubtitle}>{t(step.subtitleKey)}</div>
      <div className={styles.chips} role="group" aria-label={t(step.titleKey)}>
        {step.options.map((option) => {
          const isSelected = selected.includes(option.id);
          return (
            <button
              key={option.id}
              type="button"
              aria-pressed={isSelected}
              disabled={atCap && !isSelected}
              className={classNames(styles.chip, { [styles.chipSelected]: isSelected })}
              onClick={() => onToggle(option.id)}
            >
              {t(option.labelKey)}
            </button>
          );
        })}
      </div>
      <button type="button" className={styles.primaryCta} disabled={!canAdvance} onClick={onNext}>
        {t('hf_quiz_next')}
      </button>
    </div>
  );
}
